import PostEventSpeakers from "./PostEventSpeakers";
import ModalSpeakers from "../ModalSpeakers";

class PostEvent {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        const speakersEls = this.el.querySelectorAll('.event-speaker');
        speakersEls.forEach(speakerEl => {
            new PostEventSpeakers(speakerEl);
        });

        if (speakersEls.length) {
            const modalSpeakers = new ModalSpeakers();
        }
    }
}

export default PostEvent;
